module.exports = __webpack_public_path__ + "static/media/MVS-Logo-dark.71b5511d.png";